import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import ConfigProvider from '../config-provider';
import { obj } from '../util';

class Text extends React.Component {
  static propTypes = {
    prefix: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    text: PropTypes.string.isRequired,
    size: PropTypes.oneOf(['xxs', 'xs', 'small', 'medium', 'large', 'xl', 'xxl']),
    colorSets: PropTypes.arrayOf(PropTypes.string),
  }

  static defaultProps = {
    prefix: 'next-',
    style: {},
    size: 'medium',
    colorSets: ['#BC61CF', '#F26666', '#F29A52', '#F4C329', '#CBD057', '#289ED3', '#29B3F0'],
  }

  getBgColor = () => {
    const { text, colorSets } = this.props;
    if (typeof text !== 'string' || colorSets.length === 0 || colorSets.length === 1) {
      return '#289ED3';
    }
    const charCode = text.charCodeAt(0);
    const len = colorSets.length;
    const index = charCode % len;
    return colorSets[index];
  }

  render() {
    const { prefix, className, text, size, style, ...others } = this.props;
    const classNames = cls({
      [`${prefix}cover-text`]: true,
      [`${prefix}cover-text-${size}`]: true,
      [className]: !!className,
    });
    return (
      <div
        className={classNames}
        style={{ background: this.getBgColor(), ...style }}
        {...obj.pickAttrs(others)}
      >
        {text.slice(0, 1)}
      </div>
    );
  }
}

const Configured = ConfigProvider.config(Text);
Configured.displayName = 'Text';

export default Configured;
